document.addEventListener('DOMContentLoaded', function() {
  hoverSwatchers();
  
  window.addEventListener("klaviyoForms", function(e) {
    const { type, formId } = e.detail;

    const targetFormIds = ["WjbUT8", "XLvwXF", "Vp5AZ6"];
    if (type === "embedOpen" && targetFormIds.includes(formId)) {
      onKlaviyoFormOpen(formId);
    }
  });

  // Traducir pop-up de Klaviyo (solo si está en español o italiano)
  if (isSpanishLanguage() || isItalianLanguage()) {
    translateKlaviyoPopup();
    // Traducir botón "NOTIFY ME WHEN AVAILABLE"
    translateNotifyButton();
  }
});

// Función para obtener el idioma actual
function getCurrentLanguage() {
  // Obtener el idioma del atributo lang del HTML
  const lang = document.documentElement.lang || document.documentElement.getAttribute('lang') || '';
  return lang.toLowerCase();
}

// Función para detectar si el idioma actual es español
function isSpanishLanguage() {
  const lang = getCurrentLanguage();
  // Verificar si empieza con "es" para cubrir "es", "es-ES", "es-MX", etc.
  return lang.startsWith('es');
}

// Función para detectar si el idioma actual es italiano
function isItalianLanguage() {
  const lang = getCurrentLanguage();
  // Verificar si empieza con "it" para cubrir "it", "it-IT", etc.
  return lang.startsWith('it');
}

// Función para verificar si el idioma actual necesita traducción
function needsTranslation() {
  return isSpanishLanguage() || isItalianLanguage();
}

function updateCityDisplayKlaviyo(contentForm, countryValue) {

  let optionsCountry = contentForm.querySelectorAll('#downshift-0-menu div[role="option"]');
  let inputB2BPais = contentForm.querySelector(`input[id^="B2B_Pais_"]`);
  const restWorldLabels = ['Resto del Mundo', 'Rest of the World', 'Resto del mondo'];

  if(!optionsCountry.length || !countryValue) {
    inputB2BPais.setAttribute('data-display', 'none');
  }

  if (restWorldLabels.includes(countryValue)) {
    inputB2BPais.setAttribute('data-display', 'flex');
  } else {
    inputB2BPais.setAttribute('data-display', 'none');
  }

  optionsCountry.forEach((country) => {
    country.addEventListener('click', function() {
      let inputCountry = contentForm.querySelector('#downshift-0-input');
      if (!inputCountry) {
        return;
      }


      const isRestWorld = restWorldLabels.includes(inputCountry.value);

      inputB2BPais = contentForm.querySelector(`input[id^="B2B_Pais_"]`);
      if (!inputB2BPais) {
        return;
      }

      const container = inputB2BPais.closest('[data-testid="form-component"]');
      if (!container) {
        return;
      }

      if (isRestWorld) {
        inputB2BPais.setAttribute('data-display', 'flex');
      } else {
        inputB2BPais.setAttribute('data-display', 'none');
      }
    });
  });
}

function validCityOptions( contentForm, italian_cities, spain_cities ){
  let optionsCity = contentForm.querySelectorAll('#downshift-1-menu div[role="option"]');
  
  let inputCountry = contentForm.querySelector('#downshift-0-input');
  optionsCity.forEach((city) => {
    
    if( inputCountry.value === 'Italia' && italian_cities.includes(city.textContent) ){
      city.setAttribute('data-display', 'block');
    } 
    else if ( inputCountry.value === 'España' && spain_cities.includes(city.textContent) ) {
      city.setAttribute('data-display', 'block');
    }
    else {
      city.setAttribute('data-display', 'none');
    }
  });
};
function hoverSwatchers() {
  document.querySelectorAll(".group-colors").forEach((group) => {
    let colorLabel = group.querySelector(".color-label");
    let links = group.querySelectorAll(".link-color");
    
    if (!colorLabel || links.length === 0) return;
    
    let originalColor = colorLabel.getAttribute("original-data-color");
    
    links.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        colorLabel.dataset.color = link.dataset.color;
      });
      
      link.addEventListener("mouseleave", () => {
        colorLabel.dataset.color = originalColor;
      });
    });
  });
}

function onKlaviyoFormOpen(formId) {
  const contentForm = document.querySelector(`.klaviyo-form-${formId}.klaviyo-form`);

  if( contentForm ){
    contentForm.setAttribute('style', 'display: block !important;');
    let inputB2BPais = contentForm.querySelector(`input[id^="B2B_Pais_"]`);
    if( inputB2BPais ){
      inputB2BPais.closest('[data-testid="form-component"]').setAttribute('data-display', 'none');
    }

    let menuCountry = contentForm.querySelector('#downshift-0-input');

    if (menuCountry) {
     addKlaviyoCityEvents(contentForm, menuCountry);
    } else {
      setTimeout(() => {
        const menuCountry = contentForm.querySelector('#downshift-0-input');
        if (menuCountry) {
          addKlaviyoCityEvents(contentForm, menuCountry);
        } else {
          window.location.reload();
        }
      }, 200);
    }
  }
}

function addKlaviyoCityEvents(contentForm, menuCountry) {
  updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  menuCountry.addEventListener('click', function(event) {
    updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  });
  menuCountry.addEventListener('change', function(event) {
    updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  });
  menuCountry.addEventListener('input', function(event) {
    updateCityDisplayKlaviyo(contentForm, menuCountry.value);
  });

    const wrapper = contentForm.closest('.wim-klaviyo');
  if (wrapper) {
    setTimeout(() => { 
      wrapper.classList.add('show');
    }, 200);
  }
}
document.addEventListener('facet:update', function(event) {
  if (window.location.href.includes("filter.v.option.size") && !window.location.href.includes("filter.v.availability")) {
    window.location.href = `${window.location.href}&filter.v.availability=1`
  }
});

// Función para traducir el pop-up de Klaviyo
function translateKlaviyoPopup() {
  // Traducciones por idioma
  const translations = {
    es: {
      "Notify me when it's back": "Avísame cuando vuelva",
      "Reserve your place: get notified when the style returns": "Reserva tu lugar: recibe una notificación cuando el estilo vuelva",
      "Enter your email address": "Introduce tu dirección de correo",
      "Email": "Correo electrónico",
      "I want to receive updates and exclusive offers.": "Quiero recibir actualizaciones y ofertas exclusivas.",
      "SUBMIT": "ENVIAR",
      "Close dialog": "Cerrar diálogo",
      "Check this box to also receive promotional marketing emails.": "Marca esta casilla para recibir también correos promocionales de marketing.",
      "Thanks for subscribing!": "¡Gracias por suscribirte!",
      "Keep an eye out for a back-in-stock message.": "Mantente atento a un mensaje cuando vuelva a estar disponible.",
      "CONTINUE YOUR SHOPPING": "CONTINUAR COMPRANDO"
    },
    it: {
      "Notify me when it's back": "Avvisami quando tornerà",
      "Reserve your place: get notified when the style returns": "Prenota il tuo posto: ricevi un avviso quando questo modello ritorna",
      "Enter your email address": "Inserisci il tuo indirizzo email",
      "Email": "Email",
      "I want to receive updates and exclusive offers.": "Desidero ricevere aggiornamenti e offerte esclusive.",
      "SUBMIT": "INVIA",
      "Close dialog": "Chiudi dialogo",
      "Check this box to also receive promotional marketing emails.": "Seleziona questa casella per ricevere anche email promozionali di marketing.",
      "Thanks for subscribing!": "Grazie per esserti iscrita/o!",
      "Keep an eye out for a back-in-stock message.": "Resta in attesa del nostro avviso quando sarà di nuovo disponibile.",
      "CONTINUE YOUR SHOPPING": "CONTINUA A FARE ACQUISTI"
    }
  };

  // Obtener el idioma actual
  const currentLang = isSpanishLanguage() ? 'es' : (isItalianLanguage() ? 'it' : null);
  if (!currentLang) return;

  const langTranslations = translations[currentLang];

  // Función para traducir los textos del pop-up
  function translatePopupTexts(popupElement) {
    if (!popupElement || !needsTranslation()) return;

    // Traducir placeholder del email
    const emailInput = popupElement.querySelector('input[type="email"]');
    if (emailInput && emailInput.placeholder === "Enter your email address") {
      emailInput.placeholder = langTranslations["Enter your email address"];
    }

    // Traducir label del email
    const emailLabel = popupElement.querySelector('label[for^="email_"]');
    if (emailLabel && emailLabel.textContent.trim() === "Email") {
      emailLabel.textContent = langTranslations["Email"];
    }

    // Traducir texto del checkbox
    const checkboxLabel = popupElement.querySelector('label[for^="opt_in_promotional_email"]');
    if (checkboxLabel) {
      const labelText = checkboxLabel.querySelector('div');
      if (labelText && labelText.textContent.trim() === "I want to receive updates and exclusive offers.") {
        labelText.textContent = langTranslations["I want to receive updates and exclusive offers."];
      }
    }

    // Traducir legend del checkbox
    const checkboxLegend = popupElement.querySelector('legend[id^="kl_opt_in_promotional_email"]');
    if (checkboxLegend && checkboxLegend.textContent.trim() === "Check this box to also receive promotional marketing emails.") {
      checkboxLegend.textContent = langTranslations["Check this box to also receive promotional marketing emails."];
    }

    // Traducir todos los botones
    const buttons = popupElement.querySelectorAll('button[type="button"]');
    buttons.forEach(function(button) {
      const buttonText = button.textContent.trim();
      if (buttonText === "SUBMIT") {
        button.textContent = langTranslations["SUBMIT"];
      } else if (buttonText === "CONTINUE YOUR SHOPPING") {
        button.textContent = langTranslations["CONTINUE YOUR SHOPPING"];
      }
    });

    // Traducir todos los títulos h1
    const titleElements = popupElement.querySelectorAll('h1 span');
    titleElements.forEach(function(titleElement) {
      const titleText = titleElement.textContent.trim();
      if (titleText === "Notify me when it's back") {
        titleElement.textContent = langTranslations["Notify me when it's back"];
      } else if (titleText === "Thanks for subscribing!") {
        titleElement.textContent = langTranslations["Thanks for subscribing!"];
      }
    });

    // Traducir todos los párrafos
    const paragraphElements = popupElement.querySelectorAll('p span');
    paragraphElements.forEach(function(paragraphElement) {
      const paragraphText = paragraphElement.textContent.trim();
      if (paragraphText === "Reserve your place: get notified when the style returns") {
        paragraphElement.textContent = langTranslations["Reserve your place: get notified when the style returns"];
      } else if (paragraphText === "Keep an eye out for a back-in-stock message.") {
        paragraphElement.textContent = langTranslations["Keep an eye out for a back-in-stock message."];
      }
    });

    // Traducir aria-label del botón de cerrar
    const closeButton = popupElement.querySelector('button.klaviyo-close-form');
    if (closeButton && closeButton.getAttribute('aria-label') === "Close dialog") {
      closeButton.setAttribute('aria-label', langTranslations["Close dialog"]);
    }

    // Traducir title del SVG de cerrar
    const closeSvgTitle = popupElement.querySelector('svg[aria-hidden="true"] title');
    if (closeSvgTitle && closeSvgTitle.textContent === "Close dialog") {
      closeSvgTitle.textContent = langTranslations["Close dialog"];
    }

    // Traducir aria-label del diálogo
    const dialog = popupElement.closest('[role="dialog"]');
    if (dialog && dialog.getAttribute('aria-label') === "POPUP Form") {
      if (currentLang === 'es') {
        dialog.setAttribute('aria-label', "Formulario emergente");
      } else if (currentLang === 'it') {
        dialog.setAttribute('aria-label', "Modulo popup");
      }
    }
  }

  // Observar cambios en el DOM para detectar cuando aparece el pop-up
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Buscar el pop-up de Klaviyo
          const popup = node.querySelector && node.querySelector('[role="dialog"][aria-label="POPUP Form"]');
          if (popup) {
            // Esperar un momento para que el contenido se renderice completamente
            setTimeout(() => {
              translatePopupTexts(popup);
            }, 100);
          }
          
          // También verificar si el nodo agregado es el pop-up mismo
          if (node.getAttribute && node.getAttribute('role') === 'dialog' && node.getAttribute('aria-label') === 'POPUP Form') {
            setTimeout(() => {
              translatePopupTexts(node);
            }, 100);
          }
        }
      });

      // Observar cambios en el contenido del formulario (cuando cambia a pantalla de confirmación)
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const popup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
        if (popup) {
          setTimeout(() => {
            translatePopupTexts(popup);
          }, 100);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setTimeout(() => {
    const existingPopup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
    if (existingPopup) {
      translatePopupTexts(existingPopup);
    }
  }, 500);

  // Escuchar eventos de Klaviyo para detectar cuando se abre el pop-up o cambia el contenido
  window.addEventListener("klaviyoForms", function(e) {
    const { type } = e.detail;
    if (type === "embedOpen" || type === "open" || type === "submit" || type === "success") {
      setTimeout(() => {
        const popup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
        if (popup) {
          translatePopupTexts(popup);
        }
      }, 300);
    }
  });

  const formObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const klaviyoForm = document.querySelector('form[data-testid^="klaviyo-form-"]');
        if (klaviyoForm) {
          const popup = klaviyoForm.closest('[role="dialog"]');
          if (popup) {
            setTimeout(() => {
              translatePopupTexts(popup);
            }, 100);
          }
        }
      }
    });
  });

  
  const checkAndObserveForms = function() {
    const klaviyoForms = document.querySelectorAll('form[data-testid^="klaviyo-form-"]');
    klaviyoForms.forEach(function(form) {
      formObserver.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };

  // Verificar formularios periódicamente
  setInterval(checkAndObserveForms, 1000);
  checkAndObserveForms();
}

function translateNotifyButton() {
  if (!needsTranslation()) return;
  
  const buttonTranslations = {
    es: "AVÍSAME CUANDO ESTÉ DISPONIBLE",
    it: "AVVISAMI QUANDO È DISPONIBILE"
  };
  
  const currentLang = isSpanishLanguage() ? 'es' : (isItalianLanguage() ? 'it' : null);
  if (!currentLang) return;
  
  const translatedText = buttonTranslations[currentLang];
  
  function translateButton() {
    if (!needsTranslation()) return;
    const buttons = document.querySelectorAll('button[data-a11y-identifier^="bis-button"]');
    buttons.forEach(function(button) {
      if (button.textContent.trim() === "NOTIFY ME WHEN AVAILABLE") {
        button.textContent = translatedText;
      }
    });
    
    const allButtons = document.querySelectorAll('button');
    allButtons.forEach(function(button) {
      if (button.textContent.trim() === "NOTIFY ME WHEN AVAILABLE") {
        button.textContent = translatedText;
      }
    });
  }

  translateButton();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (!needsTranslation()) return;
        if (node.nodeType === 1) { // Element node
          // Verificar si el nodo es el botón o contiene el botón
          if (node.tagName === 'BUTTON' && node.textContent && node.textContent.trim() === "NOTIFY ME WHEN AVAILABLE") {
            node.textContent = translatedText;
          } else if (node.querySelector) {
            const button = node.querySelector('button[data-a11y-identifier^="bis-button"]');
            if (button && button.textContent.trim() === "NOTIFY ME WHEN AVAILABLE") {
              button.textContent = translatedText;
            }
          }
        }
      });
    });
    
    translateButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setInterval(translateButton, 1000);
}